import { CdkVirtualScrollable } from '@angular/cdk/scrolling';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class VirtualScrollableRegistryService {
  private scrollable$$ = new BehaviorSubject<CdkVirtualScrollable | null>(null);

  register(scrollable: CdkVirtualScrollable): void {
    this.scrollable$$.next(scrollable);
  }

  getInstance(): CdkVirtualScrollable | null {
    return this.scrollable$$.getValue();
  }

  changes(): Observable<CdkVirtualScrollable | null> {
    return this.scrollable$$.asObservable();
  }
}
